import React, {Component} from 'react';
import {List, Toast, DatePicker,} from 'antd-mobile';
import {getNear,getStation} from '../../../service/homeService';
import CityModal from "../../../components/CityModal";
import {connect} from "react-redux";
import './style.less';
import BMap from "BMap";

@connect(
    state => ({userInfo: state.userInfo})
)
export default class RunCar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cityModal:false,
            cityType:"runCar",
            modalType:"start",
            cityData:{},
            startAddress:'',
            address:'',
            appointmentTime:"",
            nowType:0,
            siteDate:"",
            province:"",
            currentCity:"",
        };
    }
    componentDidMount() {
        // let geolocation = new BMap.Geolocation();
        // const self = this;
        // geolocation.getCurrentPosition(function (r) {
        //     console.log(r)
        //     self.setState({currentCity:r.address.city});
        // });
        let data = JSON.parse(sessionStorage.getItem('homeData'));
        if(data){
            Toast.hide();
            this.setState({
                nowType:data.nowType,
                siteDate:data.siteDate,
                startAddress:data.siteDate.name,
                address:data.selAddress == undefined ? "" : data.selAddress,
                // appointmentTime:data.appointmentTime == '' ? '' : new Date(data.appointmentTime),
            })
        }else{
            this.getNearSite()
        }
    }
    getNearSite(){
        let params = {
            source:1,
            token:this.props.userInfo.token,
            data:{
                businessType:5,
                lat:this.props.poi.lat,
                lng:this.props.poi.lng,
            },
        };
        getNear(params).then((res)=>{
            Toast.hide();
            if(res.data.code == '0000'){
                if(res.data.data !== null){
                    this.setState({
                        siteDate:res.data.data,
                        startAddress:res.data.data.name,
                    })
                }
            }else{
                Toast.info(res.data.msg)
            }
        })
    }

    //获取开始城市列表
    getStartCityList = (province,letter) => {
        this.setState({province: province,cityModal: true,cityType:"runCar"});
        const params = {
            source:1,
            token:this.props.userInfo.token,
            data:{
                businessType:5,
                displayName:'',
                provinceName:province === "全部" ? "" : province,
                label:letter,
            },
        };
        getStation(params).then((res) => {
            if (res.data.code === '0000') {
                Toast.hide();
                this.setState({cityData: res.data.data});
            }else{
                Toast.info(res.data.msg,3)
            }
        })
    };
    goAddress(){
        if(this.state.siteDate == '' && this.state.nowType == 0){
            Toast.info('请先选择上车地点',2);
            return
        }
        if(this.state.siteDate == '' && this.state.nowType == 1){
            Toast.info('请先选择下车地点',2);
            return
        }
        let homeData={
            nowType:this.state.nowType,
            siteDate:this.state.siteDate,
            appointmentTime:this.state.appointmentTime,
        };
        let addressInfo={
            nowType:this.state.nowType,
            siteDate:this.state.siteDate,
            appointmentTime:this.state.appointmentTime,
            currentLocation:this.props.poi,
            startCity:this.props.currentCity,
            cityType:"runCar",
        };
        sessionStorage.setItem('homeData',JSON.stringify(homeData));
        this.props.history.push('/selAddress',addressInfo)
    }
    changeCity(n){
        this.setState({cityModal: false,cityData:[],startAddress:n.name,siteDate:n});
    }
    //预约用车
    takeCar(){
        if(this.state.address == ''){
            Toast.info('请选择地址');
            return;
        }
        if(this.state.appointmentTime == ''){
            Toast.info('请选择用车时间');
            return;
        }
        let params = {
            runType:this.state.nowType,
            siteDate:this.state.siteDate,
            address:this.state.address,
            appointmentTime:this.state.appointmentTime,
        };
        //跳转页面。清空预约信息
        sessionStorage.removeItem('homeData');
        localStorage.removeItem('homeData');
        this.props.history.push('/rideCar',params);

    }

    cityClose = () => {
        this.setState({
            cityModal: false,
            cityData: [],
        });
    };
    render() {
        return (
            <div className='runCar'>
                <div className="typeBox">
                    <div className="box">
                        <div className='type' onClick={()=>this.setState({nowType:0})}><span className={this.state.nowType == 0 ? "now" : null}>接站</span></div>
                        <div className='type' onClick={()=>this.setState({nowType:1})}><span className={this.state.nowType == 1 ? "now" :null} >送站</span></div>
                    </div>
                    {
                        this.state.nowType == 0 ?
                            <div className="area">
                                <div className="start">
                                    <i className="icon iconfont iconchufa"/>
                                    <div className="startSite"  onClick={() => this.getStartCityList()}>
                                        {this.state.startAddress === "" ? <span>哪里上车？</span> : this.state.startAddress}
                                    </div>
                                </div>
                                <div className="end">
                                    <i className="icon iconfont icondaoda"/>
                                    <div className="endSite" onClick={() =>{this.goAddress()}}>
                                        {this.state.address == '' ? <span>请输入您要到达的目的地</span> : this.state.address.endAddress}
                                    </div>
                                </div>
                            </div> :
                            <div className="area">
                                <div className="end">
                                    <i className="icon iconfont icondaoda"/>
                                    <div className="startSite"  onClick={() => this.getStartCityList()}>
                                        {this.state.startAddress === "" ? <span>哪里下车？</span> : this.state.startAddress}
                                    </div>
                                </div>
                                <div className="start">
                                    <i className="icon iconfont iconchufa"/>
                                    <div className="endSite" onClick={() =>{this.goAddress()}}>
                                        {this.state.address == '' ? <span>请输入您要出发的地址</span> : this.state.address.endAddress}
                                    </div>
                                </div>
                            </div>
                    }

                    <div className="option">
                        <DatePicker
                            mode='datetime'
                            className="dateMenu"
                            onChange={date => {
                                this.setState({ appointmentTime:date});
                            }}
                            minuteStep={5}
                            title="请选择预约时间"
                            extra="请选择预约时间"
                            minDate={new Date(+new Date() + 2100000)}
                            maxDate={new Date(+new Date() + 172800000)}
                            value={this.state.appointmentTime}

                        >
                            <List.Item ><i className="icon iconfont iconshijian1"/></List.Item>
                        </DatePicker>
                    </div>
                    <div className="reserveBtn" onClick={()=>this.takeCar()}>预约用车</div>
                </div>
                <div className="contactUs">客服热线<a href="tel:4001389889">4001389889</a></div>
                <CityModal
                    modal={this.state.cityModal}
                    modalType={this.state.modalType}//出发还是到达的modal
                    onClose={this.cityClose.bind(this)}
                    data={this.state.cityData}//城市列表数据
                    changeCity={this.changeCity.bind(this)}//切换城市事件
                    cityType = {this.state.cityType}//乘车类型
                    hotData=""//热门地州
                    nearbySite=""
                    getStartCityList={this.getStartCityList.bind(this)}
                    {...this.props}
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Home/RunCar/index.js